import React, { useEffect } from "react";
import {
  FaEnvelope,
  FaLinkedin,
  FaGithub,
  FaTwitter,
  FaInstagram,
  FaArrowUp,
} from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 700 });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const year = new Date().getFullYear();

  return (
    <footer
      className="w-full overflow-hidden px-6 py-10 bg-white/10 backdrop-blur-md border-t border-white/20 text-white mt-16"
      data-aos="fade-up"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start gap-6 text-sm md:text-base">
        {/* Left section */}
        <div className="flex-1 min-w-[200px]">
          <h3 className="text-2xl font-bold tracking-wide text-indigo-400">
            Chahat-Portfolio
          </h3>
          <p className="text-gray-400 mt-1">© {year} Chahat Jain. All rights reserved.</p>
        </div>

        {/* Contact section */}
        <div className="flex-1 min-w-[200px] flex flex-col gap-3 text-gray-300">
          <h4 className="text-indigo-300 font-semibold text-base">Contact Me</h4>

          <div
            className="flex items-center gap-2 hover:text-cyan-400 transition"
            data-tooltip-id="email-tooltip"
          >
            <FaEnvelope className="text-lg shrink-0" />
            <a href="mailto:chahatj06@gmail.com" className="hover:underline break-all">
              chahatj06@gmail.com
            </a>
          </div>
          <ReactTooltip id="email-tooltip" place="top" content="Email Me" className="!bg-gray-800 !text-white !text-xs" />

          <div
            className="flex items-center gap-2 hover:text-cyan-400 transition"
            data-tooltip-id="linkedin-tooltip"
          >
            <FaLinkedin className="text-lg shrink-0" />
            <a
              href="https://www.linkedin.com/in/chahat-jain-96b1b51b9/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline break-all"
            >
              LinkedIn
            </a>
          </div>
          <ReactTooltip id="linkedin-tooltip" place="top" content="Connect on LinkedIn" className="!bg-gray-800 !text-white !text-xs" />
        </div>

        {/* Social Icons */}
        <div className="flex-1 min-w-[200px]">
          <h4 className="text-indigo-300 font-semibold text-base mb-3">Follow Me</h4>
          <div className="flex gap-4">
            <a
              href="https://github.com/chahatj06"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip-id="github-tooltip"
              className="text-white hover:text-cyan-400 transition"
            >
              <FaGithub className="text-xl" />
            </a>
            <ReactTooltip id="github-tooltip" place="top" content="GitHub" className="!bg-gray-800 !text-white !text-xs" />

            <a
              href="https://x.com/chahatj06"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip-id="twitter-tooltip"
              className="text-white hover:text-cyan-400 transition"
            >
              <FaTwitter className="text-xl" />
            </a>
            <ReactTooltip id="twitter-tooltip" place="top" content="Twitter" className="!bg-gray-800 !text-white !text-xs" />

            <a
              href="https://www.instagram.com/chahatj23/"
              target="_blank"
              rel="noopener noreferrer"
              data-tooltip-id="instagram-tooltip"
              className="text-white hover:text-cyan-400 transition"
            >
              <FaInstagram className="text-xl" />
            </a>
            <ReactTooltip id="instagram-tooltip" place="top" content="Instagram" className="!bg-gray-800 !text-white !text-xs" />
          </div>
        </div>
      </div>

      {/* Back to Top Button (Moved inside padding to avoid overflow) */}
      <div className="mt-8 flex justify-center md:justify-end">
        <button
          onClick={scrollToTop}
          data-tooltip-id="back-to-top"
          className="bg-indigo-600 hover:bg-indigo-700 text-white p-3 rounded-full shadow-lg transition duration-300"
        >
          <FaArrowUp className="text-lg" />
        </button>
        <ReactTooltip id="back-to-top" place="left" content="Back to top" className="!bg-gray-800 !text-white !text-xs" />
      </div>
    </footer>
  );
};

export default Footer;
